<template>
  <div>
    <van-address-list
      v-model="chosenCompanyId"
      :list="list"
      :default-tag-text="$t('common.default')"
      :add-button-text="$t('address.add')"
      @add="onAdd"
      @edit="onEdit"
      @select="selectLogisticsCompany"
    />
  </div>
</template>

<script>
import { getAllCompany } from '@/api/logistics'

export default {
  data() {
    return {
      chosenCompanyId: 0,
      list: [],
      chosenAddressId: this.$route.query.addressId,
    }
  },
  created() {
    this.fetchCompany()
  },
  methods: {
    fetchCompany() {
      getAllCompany().then(res => {
        res.data.forEach(lc => {
          this.list.push({
            id: lc.id,
            name: lc.name,
            tel: lc.phone,
            address: (lc.tag ? '[' + lc.tag + '] ' :'') + lc.receivingAddress,
            isDefault: lc.isDefault,
          })
          if (lc.isDefault) {
            this.chosenCompanyId = lc.id
          }
        })
        if (this.$route.query.id) {
          this.chosenCompanyId = parseInt(this.$route.query.id)
        }
      })
    },
    onAdd() {
      this.$router.push('/logistics/edit')
    },
    onEdit(item, index) {
      this.$router.push('/logistics/edit?id=' + item.id)
    },
    selectLogisticsCompany(item, index) {
      this.$router.push('/shoppingcart?logisticsCompanyId=' + item.id + '&addressId=' + this.chosenAddressId)
    }
  }
}
</script>

<style>
.van-address-list__bottom {
  bottom: 4rem;
}
.van-address-item {
  border: 1px solid #EBEDF0;
}
</style>